import React, { useEffect, useState, useRef } from 'react'
import { Form, Formik } from 'formik'
import { Card, CardBody, CardHeader } from '../../_metronic/_partials/controls'
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { useSnackbar } from "notistack";
import { fetchPopupContent, updatePopupContent } from '../../actions/popup/popup';
import JoditEditor from "jodit-react";

export default function PopupContent() {
    
    const editor = useRef(null);
    const config = {
        readonly: false, // all options from https://xdsoft.net/jodit/doc/
        askBeforePasteHTML: false,
        askBeforePasteFromWord: false,
    };

    const dispatch = useDispatch();

    const { popupInfo } = useSelector(
        (state) => ({
            popupInfo:
                state.popupInfo?.popupContent,
        }),
        shallowEqual
    );

    useEffect(() => {
        
        async function getPopupContent() {
            await dispatch(fetchPopupContent());
        } 
        getPopupContent();

    }, [dispatch]);

    const { enqueueSnackbar } = useSnackbar();

    const initialValues = {
        description: "",
        active: false,
        wix_description: "",
        wix_popup_active: false
    }

    const [popupStatus, setpopupStatus] = useState({
        active: false,wix_popup_active: false
    });

    useEffect(() => {
        if (popupInfo && popupInfo._id) {

            setpopupStatus((prevState) => {
                const newState = { ...prevState };
                for (const inputName in newState) {
                    newState[inputName] = popupInfo[inputName];
                }
                return newState;
            });

        }
    }, [popupInfo]);

    const [isLoading, setIsLoading] = useState(false);

    const handleStatus = (e, setFieldValue) => {
        let elementName = e.target.name;

        setpopupStatus((prevState) => {
            const newState = { ...prevState };
            newState[elementName] = !prevState[elementName];
            setFieldValue(elementName, !prevState[elementName])
            return newState;
        });
    }

    const savePopupContent = (values) => {        
        if (values._id) {

            setIsLoading(true);
            const data = {
                description: values.description ? values.description : '',
                active: values.active,
                wix_description: values.wix_description ? values.wix_description : '',
                wix_popup_active: values.wix_popup_active,
            }
            
            const id = popupInfo._id;

            dispatch(updatePopupContent(data, id)).then(async (data) => {
                if (data.payload.status) {
                    if (data && data.payload) {
                        await enqueueSnackbar(data.payload.message, {
                            variant: "success",
                            autoHideDuration: 4500,
                        });
                    }
                    setIsLoading(false);
                } else {
                    await enqueueSnackbar(`${data.payload.message}`, {
                        variant: "error",
                        autoHideDuration: 1500,
                    });
                    setIsLoading(false);
                }
            });
        }
    };

    return ( 
        <>
            <Card>
                <CardHeader title={"Popup Content Info"}/>
                <CardBody>
                    <Formik
                        enableReinitialize={true}
                        initialValues={popupInfo || initialValues}
                        onSubmit={async (values, { setErrors }) => {
                            await savePopupContent(values);
                        }}
                    >
                        {({ handleSubmit, field, setFieldValue, values, handleChange }) => (
                            <> 
                                <Form className='form form-label-right'> 
                                    {/* START : SHOPIFY popup */}
                                    <div className='form-group row mt-5'>
                                        <label className="form-label col-form-label col-sm-3 text-right">Shopify Popup Content</label>
                                        <div className="col-sm-9">
                                            <JoditEditor
                                                ref={editor}
                                                value={values.description ? values.description : "" }
                                                config={config}
                                                tabIndex={5} // tabIndex of textarea
                                                onChange={(newContent) => {
                                                    setFieldValue("description", newContent);
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className='form-group row mt-5'>
                                        <label className="form-label col-form-label col-sm-3 text-right">Shopify Popup Status</label>
                                        <div className="col-sm-6">
                                            <span className="switch switch-success switch-md">
                                                <label>
                                                    <input
                                                        type="checkbox"
                                                        name="active"
                                                        onChange={(e) => {
                                                            handleStatus(e, setFieldValue)
                                                        }}
                                                        checked={popupStatus["active"]}
                                                        readOnly
                                                    />
                                                    <span></span>
                                                </label>
                                            </span>
                                        </div>
                                    </div>
                                    {/* END : SHOPIFY popup */}
                                    <div class="separator separator-dashed my-6"></div>
                                    {/* START : WIX popup */}
                                    <div className='form-group row mt-5'>
                                        <label className="form-label col-form-label col-sm-3 text-right">Wix Popup Content</label>
                                        <div className="col-sm-9">
                                            <JoditEditor
                                                ref={editor}
                                                value={values.wix_description ? values.wix_description : "" }
                                                config={config}
                                                tabIndex={5} // tabIndex of textarea
                                                onChange={(newContent) => {
                                                    setFieldValue("wix_description", newContent);
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className='form-group row mt-5'>
                                        <label className="form-label col-form-label col-sm-3 text-right">Wix Popup Status</label>
                                        <div className="col-sm-6">
                                            <span className="switch switch-success switch-md">
                                                <label>
                                                    <input
                                                        type="checkbox"
                                                        name="wix_popup_active"
                                                        onChange={(e) => {
                                                            handleStatus(e, setFieldValue)
                                                        }}
                                                        checked={popupStatus["wix_popup_active"]}
                                                        readOnly
                                                    />
                                                    <span></span>
                                                </label>
                                            </span>
                                        </div>
                                    </div>
                                    {/* END : WIX popup */} 
                                    
                                    <div className='form-group row mt-5'>
                                        <label className="form-label col-form-label col-sm-3 text-right"></label>
                                        <div className="col-sm-9">
                                            <button
                                                type='submit'
                                                style={{ float: "right" }}
                                                className='btn btn-primary'
                                                disabled={isLoading}

                                                onSubmit={() => handleSubmit()}
                                            >
                                                {isLoading ? "Submitting..." : "Submit"}
                                            </button>  
                                        </div>
                                    </div>
                                </Form>
                            </>
                        )}
                    </Formik>
                </CardBody>
            </Card>
        </>
    );


}